import { sendUIInteractionAnalyticsEvent } from '@app/services/analytics/analytics-send-event';
import { writable } from 'svelte/store';
export const changeDictionaryWidgetActive = writable(false);
function reportDictionaryWidgetOpenCloseEvent(open) {
    sendUIInteractionAnalyticsEvent({
        action: "change-dictionary-widget",
        label: open ? "open" : "close",
    });
}
export function showChangeDictionaryWidget() {
    changeDictionaryWidgetActive.set(true);
    reportDictionaryWidgetOpenCloseEvent(true);
}
export function hideChangeDictionaryWidget() {
    changeDictionaryWidgetActive.set(false);
    reportDictionaryWidgetOpenCloseEvent(false);
}
export function toggleChangeDictionaryWidget() {
    changeDictionaryWidgetActive.update(active => {
        reportDictionaryWidgetOpenCloseEvent(!active);
        return !active;
    });
}
function reportChangeLanguageWidgetOpenCloseEvent(open, type) {
    sendUIInteractionAnalyticsEvent({
        action: "change-language-widget",
        label: open ? "open" : "close",
    });
}
export const changeLanguageWidgetState = writable({ open: false });
export function showChangeLanguageWidget(type) {
    changeLanguageWidgetState.set({ open: true, type });
    reportChangeLanguageWidgetOpenCloseEvent(true, type);
}
export function hideChangeLanguageWidget() {
    changeLanguageWidgetState.set({ open: false, type: undefined });
    reportChangeLanguageWidgetOpenCloseEvent(false);
}
